import type { CommitmentVsUsageReportItem } from '@vy/types';
import { isNotEmptyArray } from '@vy/utils';
import type { FilterLineType } from '../../../../components/new-design/vyTableFilter';
import { matchesStringSelection } from '../../reports-components/shared-filter-fields';
import { formatResetCycle } from '../commitment-vs-usage-report-components/commitment-vs-usage-format-helpers';
import { COMMITMENT_VS_USAGE_FILTER_FIELD_IDS } from './commitment-vs-usage-filter-field-ids';

type FilterPredicate = (item: CommitmentVsUsageReportItem, value: unknown) => boolean;

const FIELD_PREDICATES: Record<string, FilterPredicate> = {
  [COMMITMENT_VS_USAGE_FILTER_FIELD_IDS.CustomerId]: (item, value) =>
    matchesStringSelection(item.customer.id, value),

  [COMMITMENT_VS_USAGE_FILTER_FIELD_IDS.Plan]: (item, value) =>
    matchesStringSelection(item.contract.name, value),

  [COMMITMENT_VS_USAGE_FILTER_FIELD_IDS.ContractStatus]: (item, value) =>
    matchesStringSelection(item.contract.status, value),

  [COMMITMENT_VS_USAGE_FILTER_FIELD_IDS.ResetCycle]: (item, value) =>
    matchesStringSelection(formatResetCycle(item.commitment.resetIntervalMonths), value),
};

export function applyCommitmentVsUsageFilters(
  reportItems: CommitmentVsUsageReportItem[],
  filters: FilterLineType[],
): CommitmentVsUsageReportItem[] {
  if (!isNotEmptyArray(filters)) {
    return reportItems;
  }

  return reportItems.filter((item) =>
    filters.every((filter) => {
      const predicate = FIELD_PREDICATES[filter.field];
      if (!predicate) {
        return true;
      }
      return predicate(item, filter.value);
    }),
  );
}
